// src/services/aiService.js

const SYSTEM_PROMPT = `
You are an expert Fleet Analytics AI Assistant embedded in a Vehicle Revenue Dashboard.
Your job is to analyze a single metric context and evaluate its performance.

Analyze the metric based on:
1. Current Status: Evaluate if the number is strong, concerning, or average.
2. Comparison: Contrast it against historical benchmarks or fleet targets.
3. Actionable Suggestions: Provide 2 concrete, concise operational recommendations for fleet managers.

Return your analysis strictly as a valid raw JSON object matching this key structure (no markdown fences, no extra text):
{
  "statusTag": "ON_TARGET" | "WARNING" | "CRITICAL",
  "statusSummary": "string",
  "comparisonText": "string",
  "actionableSuggestions": ["string", "string"]
}
`;
const apiUrl = process.env.REACT_APP_API_BASE_URL;

export const fetchMetricInsightFromAPI = async (metricName, metricData, token) => {
  // Construct the query text by stringifying the metric data
  const userQuery = JSON.stringify({
    metricName,
    metricData,
    timestamp: new Date().toISOString()
  });

  const response = await fetch(`${apiUrl}/api/aiserverless/ai-metric-insight`, { // Replace with manager's route path
    method: 'POST',
    headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
    body: JSON.stringify({
      content: SYSTEM_PROMPT, // Maps to req.body.content
      query: userQuery        // Maps to req.body.query
    })
  });

  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`);
  }

  const resJson = await response.json();

  if (resJson.statusCode === '0100') {
    // Handle response parsing depending on how analyticsAgentCall formats LLM outputs
    const rawContent = resJson.dataValues?.choices?.[0]?.message?.content || resJson.dataValues;
    
    // Safely parse JSON if model returned stringified JSON
    return typeof rawContent === 'string' ? JSON.parse(rawContent) : rawContent;
  } else {
    throw new Error('Failed to retrieve valid metric insights.');
  }
};